/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { Add, Replay } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';

import DoanhNghiepInsert from '../DoanhNghiepInsert';
import { techCompanyActions} from '../../../../actions';

export default function DoanhNghiepButton(props) {
  const dispatch = useDispatch();
  const profileId = useSelector(state => state.profileReducer.profile?.id);
  const totalTechCompanyList = useSelector(state => state.techCompanyReducer.totalTechCompanyList);
  const personalTechCompanyList = useSelector(state => state.techCompanyReducer?.personalTechCompanyList);

  const [inserting, setInserting] = useState(false);

  const handleClick = () => setInserting(true);
  const handleClose = () => setInserting(false);
  const handleReload = () => {
    if (props.filterType === 'person') {
      dispatch(techCompanyActions.getTechCompanysByProfileId(profileId));
    } else {
      dispatch(techCompanyActions.getAllTechCompany());
    }
  }

  useEffect(() => {
    if (props.filterType === 'person' && !isNaN(profileId) && personalTechCompanyList.length === 0) handleReload();
  }, [profileId]);

  useEffect(() => {
    if (props.filterType === 'all' && totalTechCompanyList.length === 0) handleReload();
  }, []);

  return (
    <>
      <Grid item xs={12} md={3}>
        <div style={{ float: 'right' }}>
          <Button variant='outlined' startIcon={<Replay />} style={{ backgroundColor: 'white', marginRight: 8 }} onClick={handleReload} >Tải lại</Button>
          {props.filterType === 'person' && (
            <Button variant='contained' color='secondary' startIcon={<Add />} onClick={handleClick}>Thêm</Button>
          )}
        </div>
      </Grid>


      <DoanhNghiepInsert open={inserting} onClose={handleClose} />
    </>
  );
}
